/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val, i = Math.floor(Math.abs(val)), v = val.toString().replace(/^[^.]*\.?/, '').length;

if (i === 1 && v === 0)
    return 1;
if (i === Math.floor(i) && (i >= 2 && i <= 4) && v === 0)
    return 3;
if (!(v === 0))
    return 4;
return 5;
}

export default ["sk",[["AM","PM"]],u,[["n","p","u","s","Å¡","p","s"],["ne","po","ut","st","Å¡t","pi","so"],["nedeÄ¾a","pondelok","utorok","streda","Å¡tvrtok","piatok","sobota"],["ne","po","ut","st","Å¡t","pi","so"]],u,[["j","f","m","a","m","j","j","a","s","o","n","d"],["jan","feb","mar","apr","mÃ¡j","jÃºn","jÃºl","aug","sep","okt","nov","dec"],["januÃ¡ra","februÃ¡ra","marca","aprÃ­la","mÃ¡ja","jÃºna","jÃºla","augusta","septembra","oktÃ³bra","novembra","decembra"]],[["j","f","m","a","m","j","j","a","s","o","n","d"],["jan","feb","mar","apr","mÃ¡j","jÃºn","jÃºl","aug","sep","okt","nov","dec"],["januÃ¡r","februÃ¡r","marec","aprÃ­l","mÃ¡j","jÃºn","jÃºl","august","september","oktÃ³ber","november","december"]],[["pred Kr.","po Kr."],u,["pred Kristom","po Kristovi"]],1,[6,0],["d. M. y",u,"d. MMMM y","EEEE d. MMMM y"],["H:mm","H:mm:ss","H:mm:ss z","H:mm:ss zzzz"],["{1} {0}","{1}, {0}",u,u],[",","Â ",";","%","+","-","e","Ã","â°","â","NaN",":"],["#,##0.###","#,##0Â %","#,##0.00Â Â¤","#E0"],"EUR","â¬","euro",{"AUD":[u,"$"],"BRL":[u,"R$"],"BYN":[u,"Ñ."],"CAD":[u,"$"],"CNY":[u,"Â¥"],"GBP":[u,"Â£"],"HKD":[u,"$"],"ILS":["NIS","âª"],"INR":[u,"â¹"],"JPY":[u,"Â¥"],"KRW":[u,"â©"],"NZD":[u,"$"],"PHP":[u,"â±"],"RUR":[u,"Ñ."],"TWD":[u,"NT$"],"USD":[u,"$"],"VND":[u,"â«"],"XXX":[]},"ltr", plural];
